module.exports = __webpack_public_path__ + "img/Icon_Daily_Tournament.77e198da.png";